window.handleImpressionTracking = ($el) => {
  const event = $el.data('t-event') || 'gaEvent';
  const eventAction = $el.data('t-action-impression') || '';
  const eventCategory = $el.data('t-category') || '';
  const eventLabel = $el.data('t-label') || '';

  window.dataLayer.push({
    event,
    eventAction,
    eventLabel,
    eventCategory,
    nonInteraction: false,
  });
};

$(document).ready(() => {
  if (!window.dataLayer) {
    window.dataLayer = [];
  }
  $('[data-t-action-impression]').observe(
    (evt) => {
      const el = evt[0].target;
      if (evt[0].isIntersecting) {
        const $el = $(el).closest('[data-t-action-impression]');
        // Special handling for PDP's carousels
        if ($el.hasClass('carousel__item')) {
          if ($el.hasClass('slick-current')) {
            window.handleImpressionTracking($el);
          }
        } else {
          window.handleImpressionTracking($el);
        }
      }
    },
    { threshold: 0.2 }
  );
});
